import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/meeting.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'


function Meetings() {
  const [salesUsers, setSalesUsers] = useState([]);
  const [assignUserId, setAssignUserId] = useState("");
  const [assignUserName, setAssignUserName] = useState("");
  const [meetings, setMeetings] = useState([]);
  const [filteredMeetings, setFilteredMeetings] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  const [meetingCount, setMeetingCount] = useState(0);
  const [form, setForm] = useState({
    company_name: "",
    client_name: "",
    address: "",
    meeting_date: "",
    meeting_time: ""
  });

  const userId = localStorage.getItem("userId");
  const role = localStorage.getItem("role");
  const userName = localStorage.getItem("name");

  const sendWhatsAppMessage = (data, userName) => {
    const phoneNumber = "919358654656";

    const message = `*New Meeting Scheduled*\n\n👤 Employee: ${userName}
🏢 Company: ${data.company_name}
🙍 Client: ${data.client_name}
📅 Date: ${data.meeting_date}
⏰ Time: ${data.meeting_time}
📍 Address: ${data.address}`;

    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    axios.get("http://localhost:5000/api/users/sales-users")
      .then(res => setSalesUsers(res.data))
      .catch(err => console.log(err));
  }, []);

  const formatDate = (dateString) => {
    if (!dateString || dateString.includes("1899") || dateString.includes("0000")) {
      return "-";
    }

    const date = new Date(dateString);

    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";

    const [hour, minute] = timeString.split(":");
    const date = new Date();
    date.setHours(hour, minute);

    return date.toLocaleTimeString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  };

  const fetchMeetings = async () => {
    const res = await axios.get(
      `http://localhost:5000/api/meetings?role=${role}&user_id=${userId}`
    );

    setMeetings(res.data);
    setMeetingCount(res.data.length);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const addMeeting = async (e) => {
    e.preventDefault();

    const today = new Date().toISOString().split("T")[0];

    if (form.meeting_date < today) {
      alert("❌ Past date not allowed");
      return;
    }

    if (form.meeting_date === today) {
      const currentTime = new Date().toTimeString().slice(0, 5);

      if (form.meeting_time < currentTime) {
        alert("❌ Past time not allowed");
        return;
      }
    }

    await axios.post("http://localhost:5000/api/meetings/create", {
      ...form,
      user_id: userId,
      user_role: role,
      user_name: userName
    });

    sendWhatsAppMessage(form, userName);

    setForm({
      company_name: "",
      client_name: "",
      address: "",
      meeting_date: "",
      meeting_time: ""
    });

    fetchMeetings();
  };

  const approveMeeting = async (id) => {
    await axios.put(
      `http://localhost:5000/api/meetings/approve/${id}`,
      {
        assigned_to: assignUserId,
        assigned_name: assignUserName
      }
    );
    fetchMeetings();
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  useEffect(() => {
    let filtered = [...meetings];

    if (selectedDate) {
      filtered = filtered.filter(m => m.meeting_date === selectedDate);
    }

    if (search) {
      filtered = filtered.filter(m =>
        m.company_name.toLowerCase().includes(search.toLowerCase()) ||
        m.client_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    filtered.sort((a, b) => {
      const dateA = new Date(`${a.meeting_date} ${a.meeting_time}`);
      const dateB = new Date(`${b.meeting_date} ${b.meeting_time}`);
      return dateA - dateB;
    });

    setFilteredMeetings(filtered);

  }, [meetings, search, selectedDate]);

  return (
    <>
      <div className="meetingsearch-box-navbar">
        <input
          placeholder="Search meetings..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
    <button className="search-btn">
  <span>🔍</span>
</button>
</div>

      <div className="calllogs-page">
        <div className="calllogs-container">

          <h2 style={{ marginBottom: "20px" }}>Meeting Management</h2>

          <div className="filter-box">
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>

          <form className="call-form" onSubmit={addMeeting}>
            <input name="company_name" placeholder="Company Name" value={form.company_name} onChange={handleChange} required />
            <input name="client_name" placeholder="Client Name" value={form.client_name} onChange={handleChange} required />
            <input name="address" placeholder="Address" value={form.address} onChange={handleChange} required />

            <input
              type="date"
              name="meeting_date"
              value={form.meeting_date}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
              required
            />

            <input
              type="time"
              name="meeting_time"
              value={form.meeting_time}
              onChange={(e) => {
                const selectedTime = e.target.value;
                const today = new Date().toISOString().split("T")[0];
                const currentTime = new Date().toTimeString().slice(0, 5);

                if (form.meeting_date === today && selectedTime < currentTime) {
                  alert("❌ Past time not allowed");
                  return;
                }

                setForm({ ...form, meeting_time: selectedTime });
              }}
              min={
                form.meeting_date === new Date().toISOString().split("T")[0]
                  ? new Date().toTimeString().slice(0, 5)
                  : "00:00"
              }
              required
            />

            <button>Schedule</button>
          </form>

          <table className="call-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Company</th>
                <th>Client</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Role</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredMeetings.map((m, index) => (
                <tr key={m.id}>
                  <td>{index + 1}</td>
                  <td>{m.company_name || "N/A"}</td>
                  <td>{m.client_name || "N/A"}</td>
                  <td>{formatDate(m.meeting_date)}</td>
                  <td>{formatTime(m.meeting_time)}</td>

                  <td>
                    <span style={{
                      padding: "5px 10px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      background: m.status === "pending" ? "#fff3cd" : "#d1fae5",
                      color: m.status === "pending" ? "#856404" : "#065f46"
                    }}>
                      {m.status === "approved" ? "Approved by Boss" : "Pending"}
                    </span>
                  </td>

                  <td>{m.created_role}</td>

                  <td>
                    {role === "boss" && m.status === "pending" && (
                      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                        <select
                          onChange={(e) => {
                            const selected = salesUsers.find(u => u.id == e.target.value);
                            if (selected) {
                              setAssignUserId(selected.id);
                              setAssignUserName(selected.name);
                            }
                          }}
                          style={{ padding: "6px", borderRadius: "6px" }}
                        >
                          <option value="">Select User</option>
                          {salesUsers.map(user => (
                            <option key={user.id} value={user.id}>
                              {user.name}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          onClick={() => approveMeeting(m.id)}
                          style={{
                            background: "#22c55e",
                            color: "#fff",
                            border: "none",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            cursor: "pointer"
                          }}
                        >
                          Approve
                        </button>
                      </div>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>
    </>
  );
}

export default Meetings;